import { render } from "./AppealItemView.vue?vue&type=template&id=74f01a59"
import script from "./AppealItemView.vue?vue&type=script&lang=js"
export * from "./AppealItemView.vue?vue&type=script&lang=js"

import exportComponent from "/home/le01s/WebstormProjects/am_logger_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__